import { render, staticRenderFns } from "./PopupQuizMultiple.vue?vue&type=template&id=20db0b5b&"
import script from "./PopupQuizMultiple.vue?vue&type=script&lang=js&"
export * from "./PopupQuizMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports